import { createAction, props } from "@ngrx/store";
import { CostsPerEmployee } from "../../models/cost-per-employee";

export const findCostsPerEmployeeCatalogAct = createAction('findCostsPerEmployeeCatalogEffect', props <{ id: number }>());
export const loadCostsPerEmployeeCatalogByIdAct = createAction('loadCostsPerEmployeeCatalogByIdEffect', props<{ costsPerEmployee: CostsPerEmployee }>());

export const resetCostsPerEmployeeCatalogAct = createAction('resetCostsPerEmployeeCatalogEffect');

export const updateCostsPerEmployeeCatalogAct = createAction('updateCostsPerEmployeeCatalogEffect', props<{ costsPerEmployeeUpdated: CostsPerEmployee }>());
export const updateSuccessCostsPerEmployeeCatalogAct = createAction('updateSuccessCostsPerEmployeeCatalogEffect', props<{ costsPerEmployeeUpdated: CostsPerEmployee }>());

export const saveCostsPerEmployeeCatalogAct = createAction('saveCostsPerEmployeeCatalogEffect', props<{ costsPerEmployeeNew: CostsPerEmployee }>());
export const saveSuccessCostsPerEmployeeCatalogAct = createAction('saveSuccessCostsPerEmployeeCatalogEffect', props<{ costsPerEmployeeNew: CostsPerEmployee }>());

export const setViolationsCostsPerEmployeeCatalogAct = createAction('setViolationsCostsPerEmployeeCatalogEffect', props<{ costsPerEmployeeForm: CostsPerEmployee, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );
